import { render } from "./ItemAddonMultiple.vue?vue&type=template&id=29544d5c&scoped=true&ts=true"
import script from "./ItemAddonMultiple.vue?vue&type=script&lang=ts"
export * from "./ItemAddonMultiple.vue?vue&type=script&lang=ts"

import "./ItemAddonMultiple.vue?vue&type=style&index=0&id=29544d5c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29544d5c"]])

export default __exports__